const english = {
  'Accueil': 'Home',
  'Langue du site': 'Site language',
  "Phosphokym - Retourner à l'accueil": 'Phosphokym - Return to home',
  'Certification': 'Certification',
  'À propos': 'About us',
  'DCP & Spécifications': 'DCP & Specifications',
  'Qualité & Traçabilité': 'Quality & Traceability',
  'Demander un devis': 'Request a quote',
  'Contact': 'Contact',
  'DCP · Spécifications': 'DCP · Specifications',
  'Qualité · Traçabilité': 'Quality · Traceability',
  'Fourniture B2B · Phosphate Dicalcique Feed Grade': 'B2B supply · Feed Grade Dicalcium Phosphate',
  'Équipe commerciale': 'Sales team',
  'Explorer': 'Explore',
  'Ouvrir le menu': 'Open menu',
  'Fermer le menu': 'Close menu',
  'Navigation principale': 'Main navigation',
  'Navigation mobile': 'Mobile navigation',
  'Navigation': 'Navigation',
  'DCP · Animal Nutrition': 'DCP · Animal Nutrition',
  'Produits': 'Products',
  'Nos Produits': 'Our Products',
  'Phosphate Dicalcique · Feed Grade': 'Dicalcium Phosphate · Feed Grade',
  'DCP granulaire et poudre': 'Granular and powder DCP',
  'Approvisionnement B2B sur cahier des charges': 'B2B supply to specification',
  'Tous droits réservés.': 'All rights reserved.',
  'Mentions légales': 'Legal notice',
  'Politique de confidentialité': 'Privacy policy',
  'Tél:': 'Tel:',
  'QUALITÉ': 'QUALITY',
  'PHOSPHOKYM / Supply Partner': 'PHOSPHOKYM / Supply Partner',
  'Le DCP qui sécurise votre ': 'DCP that supports your ',
  'chaîne nutritionnelle.': 'nutrition supply chain.',
  'Phosphate Dicalcique Feed Grade pour fabricants d’aliments, distributeurs et partenaires agricoles. Une offre B2B claire, documentée et adaptée à vos volumes.': 'Feed Grade Dicalcium Phosphate for feed manufacturers, distributors and agricultural partners. Clear, documented B2B supply tailored to your volumes.',
  'Voir le DCP': 'Explore DCP',
  'Qualité documentée': 'Documented quality',
  'Approvisionnement B2B': 'B2B supply',
  'Fiche produit': 'Product sheet',
  'CaHPO₄ · Matière minérale': 'CaHPO₄ · Mineral ingredient',
  'Formats': 'Formats',
  'Poudre · Granulaire': 'Powder · Granular',
  'Conditionnement': 'Packaging',
  'Sacs · Big bags · Vrac': 'Bags · Big bags · Bulk',
  'Consulter les spécifications': 'View specifications',
  'Image précédente': 'Previous image',
  'Image suivante': 'Next image',
  'Qualité contrôlée': 'Quality controlled',
  'Documentation disponible': 'Documentation available',
  'Formats flexibles': 'Flexible formats',
  'Sacs, big bags ou vrac': 'Bags, big bags or bulk',
  'Logistique coordonnée': 'Coordinated logistics',
  'Destination selon votre besoin': 'Destination tailored to your needs',
  'Réponse commerciale': 'Sales support',
  'Un interlocuteur dédié': 'A dedicated contact',
  'Une chaîne maîtrisée': 'A controlled supply chain',
  'Une matière première. Une relation fiable.': 'One ingredient. A reliable partnership.',
  'Phosphokym accompagne les achats professionnels en phosphate dicalcique avec une approche simple : comprendre votre cahier des charges, documenter la qualité et coordonner la livraison.': 'Phosphokym supports professional buyers of dicalcium phosphate with a clear approach: understand your specifications, document quality and coordinate delivery.',
  'Découvrir Phosphokym': 'Discover Phosphokym',
  'Matière première principale': 'Core ingredient',
  'Secteurs servis': 'Industries served',
  'Approvisionnement en gros': 'Bulk supply',
  'Documentation par lot': 'Batch documentation',
  'L’offre Phosphokym': 'The Phosphokym offer',
  'Le DCP selon votre réalité industrielle.': 'DCP tailored to your industrial needs.',
  'Toutes les spécifications': 'All specifications',
  'DCP · Feed Grade': 'DCP · Feed Grade',
  'Format': 'Format',
  'Emballage': 'Packaging',
  'Qualité & traçabilité': 'Quality & traceability',
  'La confiance se construit avec des preuves.': 'Trust is built on evidence.',
  'Chaque commande doit être lisible : spécifications, format, documentation et destination sont alignés avant expédition.': 'Every order should be clear: specifications, format, documentation and destination are aligned before shipment.',
  'Contrôle des lots': 'Batch controls',
  'Documentation qualité': 'Quality documentation',
  'Coordination logistique': 'Logistics coordination',
  'Notre démarche qualité': 'Our quality approach',
  'Engagement Phosphokym': 'The Phosphokym commitment',
  'Une qualité qui accompagne vos décisions d’achat.': 'Quality that supports your purchasing decisions.',
  'Management de la qualité': 'Quality management',
  'Traçabilité · amélioration continue · service B2B': 'Traceability · continuous improvement · B2B service',
  'Votre prochain approvisionnement': 'Your next supply',
  'Parlons de votre besoin en DCP.': 'Let’s discuss your DCP requirements.',
  'Volume, destination, format ou exigence documentaire : notre équipe prépare une réponse adaptée.': 'Volume, destination, format or documentation requirements: our team will prepare a tailored response.',
  'Commencer une demande de devis': 'Start a quote request',
  'Phosphokym / À propos': 'Phosphokym / About us',
  'Un partenaire fiable pour vos matières premières.': 'A reliable partner for your raw materials.',
  'Fourniture B2B de phosphate dicalcique pour la nutrition animale et le secteur agricole.': 'B2B supply of dicalcium phosphate for animal nutrition and agriculture.',
  'Notre rôle': 'Our role',
  'Rendre chaque approvisionnement plus simple à décider.': 'Make every sourcing decision simpler.',
  'Phosphokym accompagne les acheteurs professionnels dans l’approvisionnement en phosphate dicalcique. Nous clarifions les spécifications, les formats, la documentation et la logistique avant chaque commande.': 'Phosphokym supports professional buyers sourcing dicalcium phosphate. We clarify specifications, formats, documentation and logistics before every order.',
  'Notre approche est construite pour les fabricants d’aliments, distributeurs et partenaires agricoles qui recherchent une relation commerciale lisible et durable.': 'Our approach is designed for feed manufacturers, distributors and agricultural partners seeking a clear, lasting business relationship.',
  'Notre méthode': 'Our approach',
  'Trois engagements pour sécuriser votre achat.': 'Three commitments to support your purchase.',
  'Les informations produit et documents qualité sont alignés avec les exigences de chaque commande.': 'Product information and quality documents are aligned with each order’s requirements.',
  'Offre adaptée': 'A tailored offer',
  'Poudre, granulaire, sacs, big bags ou vrac selon vos contraintes industrielles.': 'Powder, granular, bags, big bags or bulk to suit your operational requirements.',
  'Une coordination claire entre volume, destination, calendrier et conditionnement.': 'Clear coordination of volume, destination, schedule and packaging.',
  'Du besoin à la livraison': 'From requirements to delivery',
  'Une coordination en quatre étapes.': 'A four-step process.',
  'Chaque étape donne à l’acheteur une visibilité claire sur l’avancement de son approvisionnement.': 'Each step gives buyers clear visibility into the progress of their order.',
  'Cahier des charges': 'Requirements',
  'Validation du produit': 'Product approval',
  'Coordination livraison': 'Delivery coordination',
  'Un interlocuteur commercial': 'Your dedicated sales contact',
  'Construisons votre prochain approvisionnement.': 'Let’s plan your next supply.',
  'Parlez-nous de votre volume, de votre destination et de vos exigences documentaires.': 'Tell us about your volume, destination and documentation requirements.',
  'Contacter l’équipe': 'Contact our team',
  'Équipe commerciale dédiée': 'Dedicated sales team',
  'Phosphokym / Produit principal': 'Phosphokym / Main product',
  'Une matière première minérale pour des chaînes de nutrition animale plus fiables.': 'A mineral ingredient for more reliable animal nutrition supply chains.',
  'Voir les spécifications': 'View specifications',
  'Formule': 'Formula',
  'Usage': 'Use',
  'Nutrition animale': 'Animal nutrition',
  'Un DCP lisible, du cahier des charges à la livraison.': 'Clear DCP supply, from requirements to delivery.',
  'Notre offre s’adresse aux fabricants d’aliments, distributeurs et partenaires agricoles qui recherchent une matière première documentée et un accompagnement commercial clair.': 'Our offer is for feed manufacturers, distributors and agricultural partners seeking a documented ingredient and clear commercial support.',
  'Formulation Feed Grade': 'Feed Grade formulation',
  'Volumes adaptés au B2B': 'Volumes tailored to B2B needs',
  'Formats d’approvisionnement': 'Supply formats',
  'Une offre organisée autour de votre usage.': 'An offer shaped around your application.',
  'Obtenir un devis': 'Get a quote',
  'Format / qualité': 'Format / quality',
  'Qualité nutrition animale': 'Animal nutrition quality',
  'Les informations essentielles, au même endroit.': 'Essential information, all in one place.',
  'Les valeurs techniques finales sont confirmées selon le lot, le cahier des charges et la documentation qualité disponible.': 'Final technical values are confirmed by batch, specification and available quality documentation.',
  'Demander la fiche technique': 'Request the technical data sheet',
  'Composition': 'Composition',
  'Application': 'Application',
  'Alimentation animale': 'Animal feed',
  'Document': 'Document',
  'Fiche technique sur demande': 'Technical data sheet available on request',
  'Une matière première pour plusieurs formulations.': 'One ingredient for multiple formulations.',
  'Volaille': 'Poultry',
  'Formulation d’aliments équilibrés pour les élevages avicoles.': 'Balanced feed formulations for poultry production.',
  'Porcs': 'Swine',
  'Approvisionnement adapté aux fabricants d’aliments porcins.': 'Supply tailored to swine feed manufacturers.',
  'Bovins & ruminants': 'Cattle & ruminants',
  'Matière minérale pour les programmes nutritionnels spécialisés.': 'A mineral ingredient for specialized nutrition programs.',
  'Aquaculture': 'Aquaculture',
  'Une solution documentée pour les formulations aquacoles.': 'A documented solution for aquaculture formulations.',
  'Votre besoin industriel': 'Your industrial requirements',
  'Parlons volumes, format et destination.': 'Let’s discuss volume, format and destination.',
  'Notre équipe prépare une réponse adaptée à votre cahier des charges d’achat.': 'Our team will prepare a response tailored to your purchasing requirements.',
  'Demander un devis DCP': 'Request a DCP quote',
  'Phosphokym / Qualité': 'Phosphokym / Quality',
  'La qualité rend l’achat plus sûr.': 'Quality makes sourcing more secure.',
  'Une démarche de contrôle et de traçabilité pensée pour les acheteurs B2B.': 'A control and traceability approach designed for B2B buyers.',
  'Documentation disponible sur demande': 'Documentation available on request',
  'Notre engagement': 'Our commitment',
  'Des informations fiables pour décider avec précision.': 'Reliable information for informed decisions.',
  'Date': 'Date',
  'Suivi': 'Review date',
  'Référence': 'Reference',
  'Notre système': 'Our system',
  'Les preuves derrière chaque commande.': 'Evidence behind every order.',
  'Documentation claire': 'Clear documentation',
  'Les éléments de qualité, de conditionnement et de traçabilité sont regroupés dans un parcours simple.': 'Quality, packaging and traceability information is organized in a clear process.',
  'Amélioration continue': 'Continuous improvement',
  'Notre démarche qualité évolue avec les retours clients et les exigences des marchés servis.': 'Our quality approach evolves with customer feedback and market requirements.',
  'Pour vos équipes': 'For your teams',
  'Une documentation utile, au bon moment.': 'Useful documentation, when you need it.',
  'La qualité ne doit pas être un obstacle administratif. Elle doit faciliter la validation fournisseur, la formulation et le suivi des lots.': 'Quality should not be an administrative obstacle. It should support supplier approval, formulation and batch tracking.',
  'Besoin d’un document ?': 'Need a document?',
  'Demandez la documentation adaptée à votre achat.': 'Request documentation tailored to your purchase.',
  'Notre équipe vous accompagne pour réunir les informations nécessaires à votre validation.': 'Our team can help gather the information you need for approval.',
  'Phosphokym / Contact B2B': 'Phosphokym / B2B contact',
  'Parlons de votre prochain approvisionnement.': 'Let’s discuss your next supply.',
  'Un besoin DCP, une question qualité ou une destination à préparer ? Notre équipe vous répond.': 'Need DCP, have a quality question or planning a destination? Our team is here to help.',
  'Téléphone': 'Phone',
  'Email commercial': 'Sales email',
  'Disponibilité': 'Availability',
  'Lundi - Vendredi · 8h00 - 16h30': 'Monday - Friday · 8:00 am - 4:30 pm',
  'Une demande bien préparée': 'A well-prepared inquiry',
  'Les informations qui accélèrent votre réponse.': 'Information that speeds up your response.',
  'Indiquez votre entreprise, votre besoin et votre destination. Notre équipe pourra vous orienter plus rapidement.': 'Share your company, requirements and destination so our team can guide you more quickly.',
  'Votre entreprise': 'Your company',
  'Identité et coordonnées': 'Company and contact details',
  'Votre besoin': 'Your requirements',
  'Sujet et contexte d’achat': 'Topic and purchasing context',
  'Notre réponse': 'Our response',
  'Un suivi commercial adapté': 'Tailored sales follow-up',
  'Nous trouver': 'Find us',
  'Une présence à Zaghouan.': 'Based in Zaghouan.',
  'Localisation Phosphokym': 'Phosphokym location',
  'Message transmis': 'Message sent',
  'Merci pour votre demande.': 'Thank you for your inquiry.',
  'Notre équipe commerciale reviendra vers vous avec les informations adaptées à votre besoin.': 'Our sales team will get back to you with information tailored to your needs.',
  'Envoyer un nouveau message': 'Send another message',
  'Formulaire de contact': 'Contact form',
  'Décrivez votre besoin.': 'Tell us what you need.',
  'Les champs marqués d’un astérisque sont obligatoires.': 'Fields marked with an asterisk are required.',
  '01 Entreprise': '01 Company',
  '02 Besoin': '02 Requirements',
  '03 Message': '03 Message',
  'Entreprise *': 'Company *',
  'Nom de votre société': 'Company name',
  'Nom complet *': 'Full name *',
  'Votre nom': 'Your name',
  'Email professionnel *': 'Business email *',
  'nom@entreprise.com': 'name@company.com',
  'Pays': 'Country',
  'Sujet *': 'Topic *',
  'Sélectionner': 'Select',
  'Demande commerciale': 'Sales inquiry',
  'Information DCP': 'DCP information',
  'Logistique / livraison': 'Logistics / delivery',
  'Volume ou besoin estimé': 'Estimated volume or requirements',
  'Ex. 20 tonnes / DCP granulaire': 'e.g. 20 tonnes / granular DCP',
  'Message *': 'Message *',
  'Destination, format, délai ou exigence particulière...': 'Destination, format, timing or specific requirements...',
  'Réponse commerciale personnalisée': 'Tailored sales response',
  'Envoyer ma demande': 'Send my inquiry',
  'Envoi en cours...': 'Sending...',
  'Veuillez compléter les champs obligatoires avant l’envoi.': 'Please complete all required fields before sending.',
  'L’envoi n’a pas abouti. Vérifiez votre connexion ou contactez-nous directement par email.': 'Your message could not be sent. Check your connection or contact us directly by email.',
  'Nom': 'Name',
  'Email': 'Email',
  'Envoyer': 'Send',
  'Société': 'Company',
  'Écrivez votre question...': 'Type your question...',
  'Votre question': 'Your question',
  'Envoyer la question': 'Send question',
  'Ouvrir l’assistant Phosphokym': 'Open the Phosphokym assistant',
  'Fermer l’assistant': 'Close assistant',
  'Informations DCP et demandes B2B': 'DCP information and B2B inquiries',
  'Bonjour ! Je suis l’assistant de PHOSPHOKYM. Comment puis-je vous aider aujourd’hui ?': 'Hello! I’m the PHOSPHOKYM assistant. How can I help you today?',
  'Produits et formats': 'Products and formats',
  'Qualité et documents': 'Quality and documentation',
  'Coordonnées': 'Contact details',
  'Être contacté par un commercial': 'Request a sales callback',
  'Je souhaite demander un devis.': 'I would like to request a quote.',
  'Quels produits et formats proposez-vous ?': 'What products and formats do you offer?',
  'Quelles certifications et quels documents qualité proposez-vous ?': 'Which certifications and quality documents do you provide?',
  'Comment vous contacter ?': 'How can I contact you?',
  'Accéder au formulaire de devis': 'Go to the quote form',
  'Voir qualité et traçabilité': 'View quality and traceability',
  'Ouvrir la page contact': 'Open the contact page',
  'Voir le DCP et ses spécifications': 'View DCP and specifications',
  'En savoir plus sur Phosphokym': 'Learn more about Phosphokym',
  'Je peux vous renseigner sur le DCP et ses formats, la qualité et les documents, les devis ou les coordonnées. Choisissez un sujet ci-dessous ou contactez directement notre équipe.': 'I can help with DCP and formats, quality and documentation, quotes, or contact details. Choose a topic below or contact our team directly.',
  'L’assistant écrit': 'The assistant is typing',
  'Annuler': 'Cancel',
  'Laissez vos coordonnées professionnelles et notre équipe pourra vous recontacter.': 'Leave your business contact details and our team can get back to you.',
  'L’envoi a échoué. Réessayez ou contactez-nous à': 'Sending failed. Please try again or contact us at',
  'Informations envoyées pour': 'Details submitted for',
  'Un commercial de': 'A sales representative from',
  'vous contactera bientôt à': 'will contact you soon at',
  'Désolé, une erreur s’est produite. Veuillez réessayer ou nous contacter directement.': 'Sorry, something went wrong. Please try again or contact us directly.',
  'Demande de devis DCP': 'DCP quote request',
  'Fournisseur B2B de Phosphate Dicalcique pour la nutrition animale et le secteur agricole': 'B2B supplier of Dicalcium Phosphate for animal nutrition and agriculture',
  'Format granulaire': 'Granular format',
  'Spécifications client': 'Customer specifications',
  'Matière première minérale destinée à la formulation d’aliments pour animaux, avec documentation qualité et accompagnement commercial B2B.': 'A mineral ingredient for animal feed formulations, with quality documentation and B2B sales support.',
  'Format adapté aux chaînes de dosage et de mélange des fabricants d’aliments pour animaux.': 'A format suited to dosing and mixing lines used by animal feed manufacturers.',
  'Une solution commerciale adaptée au volume, à la destination et aux exigences documentaires de chaque acheteur.': 'A commercial solution tailored to each buyer’s volume, destination and documentation requirements.',
  'Aliments pour volailles, porcs, bovins, ruminants et aquaculture': 'Feed for poultry, swine, cattle, ruminants and aquaculture',
  'Formulation industrielle et distribution de matières premières': 'Industrial formulation and ingredient distribution',
  'Achats en gros, contrats d’approvisionnement et export': 'Bulk purchasing, supply contracts and export',
  'Nutrition avicole': 'Poultry nutrition',
  'Bovins et ruminants': 'Cattle and ruminants',
  'Fabrication d’aliments': 'Feed manufacturing',
  'Mélanges minéraux': 'Mineral blends',
  'Premix nutritionnels': 'Nutritional premixes',
  'Distribution agricole': 'Agricultural distribution',
  'Tonnage régulier': 'Regular tonnage',
  'Livraison internationale': 'International delivery',
  'Support commercial': 'Sales support',
  'Processus de production optimisés': 'Optimized production processes',
  'Contrôle qualité rigoureux à chaque étape': 'Rigorous quality control at every stage',
  'Amélioration continue des performances': 'Continuous performance improvement',
  'Satisfaction client garantie': 'Customer satisfaction',
  'Traçabilité complète des produits': 'Full product traceability',
  'Système de Management de la Qualité': 'Quality Management System',
  'Documentation qualité disponible sur demande': 'Quality documentation available on request'
  , 'Pour préparer une offre adaptée, précisez votre volume, votre destination et le format souhaité. Notre équipe commerciale pourra étudier votre demande.': 'To prepare a tailored offer, please share your volume, destination and preferred format. Our sales team will review your request.'
  , 'Phosphokym est certifiée ISO 22000:2018. Les documents qualité et informations disponibles peuvent être demandés à notre équipe selon votre besoin.': 'Phosphokym is ISO 22000:2018 certified. Quality documents and available information can be requested from our team to suit your needs.'
  , 'Adresse': 'Address'
  , 'Notre offre principale est le phosphate dicalcique (DCP) Feed Grade pour la nutrition animale. Selon le besoin, il est proposé en poudre ou en format granulaire, avec conditionnement à préciser selon la commande.': 'Our main offer is Feed Grade dicalcium phosphate (DCP) for animal nutrition. It is available as powder or granules, with packaging confirmed for each order.'
  , 'Phosphokym accompagne les acheteurs professionnels dans leur approvisionnement en phosphate dicalcique pour la nutrition animale et le secteur agricole.': 'Phosphokym supports professional buyers sourcing dicalcium phosphate for animal nutrition and agriculture.'
  , 'Demande de contact commercial': 'Sales contact request'
  , 'Merci': 'Thank you'
  , 'Assistant': 'Assistant'
  , 'Société *': 'Company *'
  , 'Nom *': 'Name *'
  , 'Voir la documentation qualité': 'View quality documentation'
  , 'Veuillez entrer une adresse email valide.': 'Please enter a valid email address.'
  , 'Veuillez entrer un numéro de téléphone valide avec l’indicatif international.': 'Please enter a valid phone number with the international dialing code.'
  , 'Le nom de la société doit contenir au moins 2 caractères.': 'The company name must contain at least 2 characters.'
  , 'Le nom complet doit contenir au moins 2 caractères.': 'The full name must contain at least 2 characters.'
  , 'Veuillez sélectionner un produit.': 'Please select a product.'
  , 'Veuillez entrer une quantité valide supérieure à 0.': 'Please enter a valid quantity greater than 0.'
  , 'Erreur :': 'Error:'
  , 'Veuillez vérifier votre connexion et réessayer ou nous contacter directement.': 'Please check your connection and try again, or contact us directly.'
  , 'Indiquez votre tonnage, destination et exigences qualité pour recevoir une proposition adaptée.': 'Share your tonnage, destination and quality requirements to receive a tailored quote.'
  , 'Demande Envoyée avec Succès !': 'Request sent successfully!'
  , 'de votre intérêt pour Phosphokym.': 'for your interest in Phosphokym.'
  , 'Votre demande a été envoyée à notre équipe commerciale.': 'Your request has been sent to our sales team.'
  , 'Nous vous contacterons sous': 'We will contact you within'
  , 'à :': 'at:'
  , 'Récapitulatif de votre demande': 'Request summary'
  , 'Société :': 'Company:'
  , 'Produit :': 'Product:'
  , 'Quantité :': 'Quantity:'
  , 'Usage :': 'Application:'
  , 'Vous recevrez également une copie de cette demande par email.': 'You will also receive a copy of this request by email.'
  , 'Demande de Devis Personnalisé': 'Request a tailored quote'
  , 'Remplissez ce formulaire pour recevoir un devis adapté à vos besoins': 'Complete this form to receive a quote tailored to your needs.'
  , 'Informations Client': 'Customer information'
  , 'Nom de votre entreprise': 'Company name'
  , 'Nom & Prénom *': 'Full name *'
  , 'Votre nom complet': 'Your full name'
  , 'Email *': 'Email *'
  , 'nom@exemple.com': 'name@example.com'
  , 'Téléphone *': 'Phone *'
  , 'votre numéro de téléphone': 'your phone number'
  , 'Pays *': 'Country *'
  , 'Demande Spécifique': 'Order requirements'
  , 'Produit souhaité *': 'Product *'
  , 'Sélectionnez un produit': 'Select a product'
  , 'Quantité *': 'Quantity *'
  , 'Tonnes': 'Tonnes'
  , 'Fûts': 'Drums'
  , 'Citernes': 'Tanker loads'
  , 'Usage industriel': 'Industrial application'
  , 'Sélectionnez...': 'Select...'
  , 'Autre': 'Other'
  , 'Informations complémentaires': 'Additional information'
  , 'Spécifications techniques, délais, conditionnement particulier...': 'Technical specifications, timeline or special packaging requirements...'
  , 'Engagement Phosphokym :': 'The Phosphokym commitment:'
  , 'Devis personnalisé sous 24h • Produits certifiés ISO 22000 • Support technique inclus': 'Tailored quote within 24 hours • ISO 22000-certified products • Technical support included'
  , 'Envoyer ma demande de devis': 'Submit my quote request'
  , 'Contact direct disponible': 'Prefer to contact us directly?'
  , 'accompagne les acheteurs professionnels dans l’approvisionnement en phosphate dicalcique. Nous clarifions les spécifications, les formats, la documentation et la logistique avant chaque commande.': 'supports professional buyers sourcing dicalcium phosphate. We clarify specifications, formats, documentation and logistics before every order.'
  , 'Phosphate Dicalcique': 'Dicalcium Phosphate'
  , 'Lecture technique': 'Technical overview'
  , 'Afghanistan': 'Afghanistan'
  , 'Allemagne': 'Germany'
  , 'Algérie': 'Algeria'
  , 'Arabie Saoudite': 'Saudi Arabia'
  , 'Argentine': 'Argentina'
  , 'Australie': 'Australia'
  , 'Bahreïn': 'Bahrain'
  , 'Bangladesh': 'Bangladesh'
  , 'Belgique': 'Belgium'
  , 'Bhoutan': 'Bhutan'
  , 'Birmanie': 'Myanmar'
  , 'Bolivie': 'Bolivia'
  , 'Brésil': 'Brazil'
  , 'Cambodge': 'Cambodia'
  , 'Canada': 'Canada'
  , 'Chili': 'Chile'
  , 'Chine': 'China'
  , 'Chypre': 'Cyprus'
  , 'Colombie': 'Colombia'
  , 'Corée du Nord': 'North Korea'
  , 'Corée du Sud': 'South Korea'
  , 'Égypte': 'Egypt'
  , 'Émirats Arabes Unis': 'United Arab Emirates'
  , 'Équateur': 'Ecuador'
  , 'Espagne': 'Spain'
  , 'États-Unis': 'United States'
  , 'Fidji': 'Fiji'
  , 'France': 'France'
  , 'Grèce': 'Greece'
  , 'Guyana': 'Guyana'
  , 'Guyane Française': 'French Guiana'
  , 'Hong Kong': 'Hong Kong'
  , 'Inde': 'India'
  , 'Indonésie': 'Indonesia'
  , 'Iran': 'Iran'
  , 'Irak': 'Iraq'
  , 'Italie': 'Italy'
  , 'Japon': 'Japan'
  , 'Jordanie': 'Jordan'
  , 'Kiribati': 'Kiribati'
  , 'Koweït': 'Kuwait'
  , 'Laos': 'Laos'
  , 'Liban': 'Lebanon'
  , 'Libye': 'Libya'
  , 'Macao': 'Macao'
  , 'Malaisie': 'Malaysia'
  , 'Maldives': 'Maldives'
  , 'Malte': 'Malta'
  , 'Maroc': 'Morocco'
  , 'Mexique': 'Mexico'
  , 'Micronésie': 'Micronesia'
  , 'Nauru': 'Nauru'
  , 'Népal': 'Nepal'
  , 'Nouvelle-Zélande': 'New Zealand'
  , 'Oman': 'Oman'
  , 'palestine': 'Palestine'
  , 'Pakistan': 'Pakistan'
  , 'Palaos': 'Palau'
  , 'Papouasie-Nouvelle-Guinée': 'Papua New Guinea'
  , 'Paraguay': 'Paraguay'
  , 'Pérou': 'Peru'
  , 'Philippines': 'Philippines'
  , 'Portugal': 'Portugal'
  , 'Qatar': 'Qatar'
  , 'Royaume-Uni': 'United Kingdom'
  , 'Singapour': 'Singapore'
  , 'Sri Lanka': 'Sri Lanka'
  , 'Suriname': 'Suriname'
  , 'Suisse': 'Switzerland'
  , 'Syrie': 'Syria'
  , 'Taïwan': 'Taiwan'
  , 'Thaïlande': 'Thailand'
  , 'Tonga': 'Tonga'
  , 'Tunisie': 'Tunisia'
  , 'Turquie': 'Türkiye'
  , 'Tuvalu': 'Tuvalu'
  , 'Uruguay': 'Uruguay'
  , 'Vanuatu': 'Vanuatu'
  , 'Venezuela': 'Venezuela'
  , 'Vietnam': 'Vietnam'
  , 'Yémen': 'Yemen'
  , 'Îles Marshall': 'Marshall Islands'
  , 'Îles Salomon': 'Solomon Islands'
  , 'Phosphate Dicalcique Feed Grade': 'Feed Grade Dicalcium Phosphate'
  , 'DCP Granulaire': 'Granular DCP'
  , 'Approvisionnement sur cahier des charges': 'Supply to specification'
  , 'DCP · CaHPO₄': 'DCP · CaHPO₄'
  , 'Sacs 25 kg, big bags, vrac': '25 kg bags, big bags, bulk'
  , 'Veuillez entrer un numéro de téléphone valide avec l\'indicatif international.': 'Please enter a valid phone number with the international dialing code.'
  , 'Volume': 'Volume'
    , 'Big bags, vrac selon besoin': 'Big bags or bulk, depending on requirements'
    , 'Selon destination et incoterm': 'Depending on destination and Incoterms'
    , 'Conteneur': 'Container'
    , 'Phosphokym structure son approvisionnement autour de contrôles documentés, de la traçabilité des lots et d’un accompagnement adapté aux exigences des acheteurs professionnels.': 'Phosphokym structures its supply around documented controls, batch traceability and support tailored to professional buyers’ requirements.'
    , 'Les informations techniques et documents associés sont préparés pour répondre aux besoins de l’acheteur.': 'Technical information and supporting documents are prepared to meet the buyer’s needs.'
    , 'Granulaire': 'Granular'
    , 'Big bags': 'Big bags'
    , 'DCP granulaire': 'Granular DCP'
    , 'Conditionné en big bags': 'Packed in big bags'
    , 'DCP Granulaire · Feed Grade': 'Granular DCP · Feed Grade'
    , 'Granulé DCP conditionné en big bags pour les acheteurs B2B.': 'Granular DCP packed in big bags for B2B buyers.'
    , 'Notre offre est un DCP Feed Grade granulé, conditionné en big bags pour la nutrition animale.': 'Our offer is Feed Grade granular DCP, packed in big bags for animal nutrition.'
    , 'Notre produit': 'Our product'
    , 'Phosphate dicalcique Feed Grade sous forme granulée, conditionné en big bags pour les fabricants d’aliments et les acheteurs B2B.': 'Feed Grade granular dicalcium phosphate, packed in big bags for feed manufacturers and B2B buyers.'
};

export const translate = (language, frenchText) => (
  language === 'en' ? (english[frenchText] || frenchText) : frenchText
);
